import React, { useState } from 'react';
import { VisaDetail } from '../../../types/PackageBuilder';
import { Input } from '../UIPrimitives';

type VisaDetailsModalProps = {
  currency: 'INR' | 'USD';
  onClose: () => void;
  onSave: (detail: VisaDetail) => void;
};

const VisaDetailsModal: React.FC<VisaDetailsModalProps> = ({ currency, onClose, onSave }) => {
  const [visaType, setVisaType] = useState('');
  const [price, setPrice] = useState<number>(0);
  const [validity, setValidity] = useState('');
  const [timeRequired, setTimeRequired] = useState('');
  const [documents, setDocuments] = useState<string[]>([]);
  const [documentDraft, setDocumentDraft] = useState('');

  const addDocument = () => {
    const next = documentDraft.trim();
    if (!next) return;
    setDocuments((prev) => Array.from(new Set([...prev, next])));
    setDocumentDraft('');
  };

  const removeDocument = (index: number) => {
    setDocuments((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSave = () => {
    if (!visaType.trim()) return;
    onSave({
      type: visaType.trim(),
      price: Number(price || 0),
      validity: validity.trim(),
      documents,
      timeRequired: timeRequired.trim(),
      currency,
    });
  };

  return (
    <div className="modal-backdrop">
      <div className="modal modal-lg">
        <button className="close-btn" onClick={onClose} aria-label="Close">×</button>
        <div className="modal-header">
          <h2>Add Visa Details</h2>
        </div>
        <div className="modal-body">
          <label>
            Visa type
            <input
              value={visaType}
              onChange={(event) => setVisaType(event.target.value)}
              placeholder="e-Visa, Tourist, etc."
            />
          </label>
          <label>
            Price ({currency})
            <input
              type="number"
              min={0}
              value={price}
              onChange={(event) => setPrice(Number(event.target.value || 0))}
              placeholder="0"
            />
          </label>
          <label>
            Validity
            <input
              value={validity}
              onChange={(event) => setValidity(event.target.value)}
              placeholder="30 days, 90 days, etc."
            />
          </label>
          <label>
            Time required to get visa
            <input
              value={timeRequired}
              onChange={(event) => setTimeRequired(event.target.value)}
              placeholder="2-3 working days"
            />
          </label>
          <label>
            Documents needed
            <div className="package-editor-tag-input-container">
              <Input
                value={documentDraft}
                onChange={(event) => setDocumentDraft(event.target.value)}
                placeholder="Passport, Photo, Bank statement"
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    event.preventDefault();
                    addDocument();
                  }
                }}
              />
              <button type="button" className="package-editor-btn-primary" onClick={addDocument}>
                Add
              </button>
            </div>
          </label>
          <div className="package-editor-tags-container">
            {documents.map((document, index) => (
              <span key={`${document}-${index}`} className="package-editor-tag">
                {document}
                <button
                  type="button"
                  className="package-editor-remove-btn"
                  onClick={() => removeDocument(index)}
                  aria-label="remove"
                >
                  ✕
                </button>
              </span>
            ))}
          </div>
        </div>
        <div className="modal-actions">
          <button type="button" onClick={handleSave} disabled={!visaType.trim()}>
            Add
          </button>
          <button type="button" className="secondary" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default VisaDetailsModal;
